/**
 * Requests inbox (tracker item 45, phase 4): service requests (the customer portal's, and the web
 * form's later), reschedule requests and portal access requests, one tab each with a status
 * filter and paging. ADMIN and OFFICE_MANAGER (backend requireRole on every route behind it).
 * The tab is in the URL (?tab=), so a link goes straight to one; there is no polling.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { REQUEST_TABS, RequestsTab, tabFromParam } from './requestsUi';
import { ServiceRequestsTab } from './ServiceRequestsTab';
import { RescheduleRequestsTab } from './RescheduleRequestsTab';
import { AccessRequestsTab } from './AccessRequestsTab';

export function RequestsPage() {
  const [params, setParams] = useSearchParams();
  const tab = tabFromParam(params.get('tab'));
  const choose = (next: RequestsTab) => setParams(next === 'service' ? {} : { tab: next }, { replace: true });

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <h1 className="text-2xl font-bold text-gray-900">Requests</h1>
      <p className="mt-1 text-sm text-gray-600">What customers have asked for through the customer portal. Reload the page to see new ones.</p>

      <div role="tablist" aria-label="Request types" className="mt-4 flex flex-wrap gap-2 border-b border-gray-200 pb-2">
        {REQUEST_TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            id={`tab-${t.id}`}
            aria-selected={tab === t.id}
            aria-controls={`panel-${t.id}`}
            onClick={() => choose(t.id)}
            className={`min-h-[44px] rounded-md px-4 text-sm font-semibold ${tab === t.id ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 ring-1 ring-gray-300 hover:bg-gray-50'}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div role="tabpanel" id={`panel-${tab}`} aria-labelledby={`tab-${tab}`} className="mt-4">
        {tab === 'service' && <ServiceRequestsTab />}
        {tab === 'reschedule' && <RescheduleRequestsTab />}
        {tab === 'access' && <AccessRequestsTab />}
      </div>
    </main>
  );
}
